// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductDetails_wrapper__HnUlt","contentWrapper":"ProductDetails_contentWrapper__uIJkY"};